module.exports = __webpack_public_path__ + "videos/40fce31ffc36e04167207ba43f2cfcb1.mp4";